export default __webpack_public_path__ + "static/07.03-14b259156ea29a1aab9bc38529dd8a36.png";